import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";
import { Link } from "react-router-dom";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    orderNumber: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Please enter your full name.";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email address.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid email.";
    }

    if (formData.orderNumber && formData.orderNumber.trim().length < 5) {
      newErrors.orderNumber = "Order number should be at least 5 characters.";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Please enter your message.";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters.";
    }

    return newErrors;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setStatus(null);
      return;
    }

    setStatus("Your message has been sent. We will get back to you soon.");
    setShowSuccess(true);
    setErrors({});
    setFormData({
      name: "",
      email: "",
      orderNumber: "",
      message: "",
    });
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="policy-page">
          <div className="policy-container">
            <h1>Contact Us</h1>

            <section className="policy-section">
              <h2>Customer Support Hours</h2>
              <ul>
                <li>Monday–Friday: 9:00 – 18:00 (local time)</li>
                <li>Saturday: 10:00 – 16:00</li>
                <li>Sunday & public holidays: Online support only</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Contact Form</h2>
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="form-field">
                  <label htmlFor="contact-name">Full Name *</label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                    minLength={2}
                  />
                  {errors.name && (
                    <p
                      className="form-error"
                      style={{ marginTop: "5px", color: "red" }}
                    >
                      {errors.name}
                    </p>
                  )}
                </div>

                <div className="form-field">
                  <label htmlFor="contact-email">Email *</label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="name@example.com"
                    required
                  />
                  {errors.email && (
                    <p
                      className="form-error"
                      style={{ marginTop: "5px", color: "red" }}
                    >
                      {errors.email}
                    </p>
                  )}
                </div>

                <div className="form-field">
                  <label htmlFor="contact-order">Order Number (optional)</label>
                  <input
                    id="contact-order"
                    type="text"
                    name="orderNumber"
                    value={formData.orderNumber}
                    onChange={handleChange}
                    placeholder="e.g. ESG12345"
                  />
                  {errors.orderNumber && (
                    <p
                      className="form-error"
                      style={{ marginTop: "5px", color: "red" }}
                    >
                      {errors.orderNumber}
                    </p>
                  )}
                </div>

                <div className="form-field">
                  <label htmlFor="contact-message">Message *</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we assist you?"
                    rows={5}
                    required
                    minLength={10}
                  />
                  {errors.message && (
                    <p
                      className="form-error"
                      style={{ marginTop: "5px", color: "red" }}
                    >
                      {errors.message}
                    </p>
                  )}
                </div>

                <button className="btn-primary" type="submit">
                  Submit
                </button>
                {showSuccess && (
                  <div className="form-success">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      width="20"
                      height="20"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Message sent successfully! We will get back to you within
                    1-2 business days.
                  </div>
                )}
                {status && !showSuccess && (
                  <p className="form-status">{status}</p>
                )}
              </form>
            </section>

            <section className="policy-section">
              <h2>Other Ways to Reach Us</h2>
              <ul>
                <li>Email: life@manyou.fun</li>
              </ul>
            </section>

            <div className="policy-actions">
              <button className="btn-primary" onClick={toTop}>
                Back to Top
              </button>
              <Link className="link-underline" to="/shop" onClick={toTop}>
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Contact;
